import Select2 from "./Select2.vue";

export default {
    install(Vue, opts){
        Vue.component('select2', Select2)
    }
}